<template>
  <div>
    <div class="admin_title" style="position: relative">小分类管理 <router-link :to="{path: prefix + '/org/examClassification_f/' + this.$utils.URLencode(this.$route.params.path) + '/'  + this.$route.params.id}" class="class_back_top">返回</router-link></div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <a href="javascript:;" @click="edit(null, null)">新增分类</a>
    </div>
    <div class="add_shijuan_con mmHeight">
      <table id="customers">
        <tr>
          <th width="50%">小分类名称</th>
          <th width="15%">排序</th>
          <th width="35%">操作</th>
        </tr>
        <tr v-for="item in list" :key="item.value">
          <td>{{item.label}}</td>
          <td>暂无排序</td>
          <td>
            <a href="javascript:;" class="red_font_a" @click="del(item.id)">删除</a>
            <a href="javascript:;" class="red_font_a" @click="edit(item.id, item.label, item.value)">修改</a>
          </td>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
    <!--/右侧内容-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name" placeholder="请输入小分类名称"/></dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')"/>　　<input name=""
                                                                                                       type="button"
                                                                                                       value="确定"
                                                                                                       class="red_color"
                                                                                                       @click="submitClassification(name, name_sort, value)"/>
          </dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
  </div>
</template>
<script>

export default {
  components: {},
  data () {
    return {
      filter: {
        type: 'examPaperMiddleType'
      },
      list: [],
      pages: 0,
      cnt: 0,
      classification: {},
      name: '',
      value: '',
      name_sort: '0',
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    this.getClassifications(this.filter)
  },
  mounted () {
    this.$nextTick(() => {})
  },
  computed: {},
  methods: {
    getClassifications (filter) {
      this.$api.post(this.$global.examApiPath, '/dict/get', filter, r => {
        this.cnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
        this.list = r.data
      })
    },
    // 编辑小分类
    edit(id, name, value) {
      if (name == null) {
        this.$utils.fadeIn('.add_s_menu')
        this.name = ''
        this.value = ''
      } else if (name != null) {
        this.$utils.fadeIn('.add_s_menu')
        this.name = name
        this.value = value
      }
      this.classification = {
        type: "examPaperMiddleType",
        id: id
      }
    },
    submitClassification(name, sort, value) {
      if (name && name != '') {
        this.classification.label = name
        this.classification.sort = sort
        this.classification.value = value
        this.$api.post(this.$global.examApiPath, '/dict/save', this.classification, r => {
          this.classification = {}
          this.$utils.fadeOut('.add_s_menu')
          this.getClassifications(this.filter)
        })
      }
    },
    del (id) {
      this.$api.post(this.$global.examApiPath, '/dict/delete', {id: id}, r => {
        this.getClassifications(this.filter)
      })
    },
    goBack () {
      this.$router.push({path: this.prefix + '/org/examClassification_f/'+ this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id})
    }
  }
}
</script>
<style lang="scss">
  .name_f_span{display:inline-block; margin-left:10px; margin-top:9px;}
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/classification_s.vue